// Dialogues : <dialog> natif (Échap, piège de focus, retour du focus, clic sur le voile), rendus en promesse.
//   dialogue.confirmer({ titre, message, ok, annuler, danger }) → true / false
//   dialogue.alerter({ titre, message }) → true
//   dialogue.demander({ titre, message, valeur, placeholder, ok }) → chaîne saisie ou null
//   dialogue.grille({ titre, message, lignes, ajout, apercu }) → un nombre par ligne, ou null
// Remplace alert() / confirm() / prompt(), qui figent la page et ignorent la charte.
import { html } from '../../core/html.js';

function ouvrir(contenu, opts) {
    return new Promise(function(resolve) {
        var d = document.createElement('dialog');
        d.className = 'dlg';
        d.innerHTML = String(contenu);
        document.body.appendChild(d);
        var precedent = document.activeElement, fini = false;
        function clore(valeur) {
            if (fini) return; fini = true;
            d.classList.add('sortie');
            setTimeout(function() { try { d.close(); } catch (e) {} d.remove(); if (precedent && precedent.focus) { try { precedent.focus(); } catch (e) {} } resolve(valeur); }, 130);
        }
        d.addEventListener('cancel', function(ev) { ev.preventDefault(); clore(opts.annulation); });
        d.addEventListener('click', function(ev) { if (ev.target === d) clore(opts.annulation); });
        d.querySelectorAll('[data-dlg]').forEach(function(b) { b.addEventListener('click', function() { clore(opts.valeur(b.getAttribute('data-dlg'), d)); }); });
        var form = d.querySelector('form');
        if (form) form.addEventListener('submit', function(ev) { ev.preventDefault(); clore(opts.valeur('ok', d)); });
        if (opts.monter) opts.monter(d);
        d.showModal();
        var f = d.querySelector('[autofocus]') || d.querySelector('input, .btn-fantome, .btn-primaire, button');
        if (f) f.focus();
    });
}
function norm(o, cle) { return typeof o === 'string' ? (function() { var x = {}; x[cle] = o; return x; })() : (o || {}); }

export function confirmer(o) {
    o = norm(o, 'message');
    return ouvrir(html`<div class="dlg-corps">${o.titre ? html`<h2>${o.titre}</h2>` : ''}<p>${o.message || ''}</p>
        <div class="dlg-actions"><button type="button" class="btn btn-fantome" data-dlg="annuler"${o.danger ? html` autofocus` : ''}>${o.annuler || 'Annuler'}</button><button type="button" class="btn ${o.danger ? 'btn-danger' : 'btn-primaire'}" data-dlg="ok"${o.danger ? '' : html` autofocus`}>${o.ok || 'Confirmer'}</button></div></div>`,
        { annulation: false, valeur: function(k) { return k === 'ok'; } });
}
export function alerter(o) {
    o = norm(o, 'message');
    return ouvrir(html`<div class="dlg-corps">${o.titre ? html`<h2>${o.titre}</h2>` : ''}<p>${o.message || ''}</p>
        <div class="dlg-actions"><button type="button" class="btn btn-primaire" data-dlg="ok" autofocus>${o.ok || 'OK'}</button></div></div>`,
        { annulation: true, valeur: function() { return true; } });
}
export function demander(o) {
    o = norm(o, 'message');
    return ouvrir(html`<form class="dlg-corps" method="dialog">${o.titre ? html`<h2>${o.titre}</h2>` : ''}${o.message ? html`<p>${o.message}</p>` : ''}
        <div class="champ"><label for="dlg-saisie">${o.label || 'Nom'}</label><input id="dlg-saisie" class="saisie" type="${o.type || 'text'}" value="${o.valeur || ''}" placeholder="${o.placeholder || ''}" autocomplete="off" autofocus></div>
        <div class="dlg-actions"><button type="button" class="btn btn-fantome" data-dlg="annuler">${o.annuler || 'Annuler'}</button><button type="submit" class="btn btn-primaire">${o.ok || 'Valider'}</button></div></form>`,
        { annulation: null, valeur: function(k, d) { if (k !== 'ok') return null; var v = d.querySelector('input').value.trim(); return v || null; } });
}
// Une grille de réglages chiffrés, une ligne par jour, avec un aperçu commun.
//   dialogue.grille({ titre, message, lignes: [{label, valeur}], min, max, ajout: {label, ligne(i)},
//                     apercu(valeurs) → texte, ok, annuler }) → tableau de nombres, ou null
//
// L'aperçu se rafraîchit à la frappe en n'écrivant QUE dans son propre nœud de texte, et ajouter un jour
// n'ajoute qu'une ligne : redessiner la fenêtre arracherait le champ en cours de saisie, et le focus avec lui.
// C'est exactement l'accident qu'on a déjà eu sur les réglages du planning.
export function grille(o) {
    o = o || {};
    var min = o.min == null ? 0 : o.min, max = o.max == null ? 999 : o.max;
    var ligneHtml = function(i, l) {
        return html`<li class="dlg-ligne">
            <label for="dlg-part-${String(i)}">${l.label}</label>
            <input id="dlg-part-${String(i)}" class="saisie" data-part type="number" inputmode="numeric" step="1"
                min="${String(min)}" max="${String(max)}" value="${String(l.valeur)}" autocomplete="off"${i === 0 ? html` autofocus` : ''}>
        </li>`;
    };
    var lire = function(d) {
        return Array.prototype.map.call(d.querySelectorAll('[data-part]'), function(c) {
            var v = parseInt(c.value, 10);
            return Math.max(min, Math.min(max, isNaN(v) ? 0 : v));
        });
    };
    return ouvrir(html`<form class="dlg-corps dlg-corps--grille" method="dialog">
        ${o.titre ? html`<h2>${o.titre}</h2>` : ''}
        ${o.message ? html`<p>${o.message}</p>` : ''}
        <ul class="dlg-grille">${(o.lignes || []).map(function(l, i) { return ligneHtml(i, l); })}</ul>
        ${o.ajout ? html`<button type="button" class="btn btn-fantome btn-sm" data-ajout>${o.ajout.label}</button>` : ''}
        <p class="dlg-apercu" id="dlg-apercu" role="status" aria-live="polite"></p>
        <div class="dlg-actions">
            <button type="button" class="btn btn-fantome" data-dlg="annuler">${o.annuler || 'Annuler'}</button>
            <button type="submit" class="btn btn-primaire">${o.ok || 'Valider'}</button>
        </div></form>`,
        {
            annulation: null,
            valeur: function(k, d) { return k === 'ok' ? lire(d) : null; },
            monter: function(d) {
                var vue = d.querySelector('#dlg-apercu'), liste = d.querySelector('.dlg-grille');
                var rafraichir = function() { if (o.apercu) vue.textContent = o.apercu(lire(d)); };
                d.addEventListener('input', function(ev) { if (ev.target.hasAttribute('data-part')) rafraichir(); });
                var plus = d.querySelector('[data-ajout]');
                if (plus) plus.addEventListener('click', function() {
                    var i = liste.children.length;
                    if (i >= 60) { plus.disabled = true; return; }   // au-delà, le rattrapage ne rattrape plus rien
                    liste.insertAdjacentHTML('beforeend', String(ligneHtml(i, o.ajout.ligne(i))));
                    var neuf = liste.lastElementChild.querySelector('input');
                    neuf.removeAttribute('autofocus'); neuf.focus(); neuf.select();
                    rafraichir();
                });
                rafraichir();
            },
        });
}
export var dialogue = { confirmer: confirmer, alerter: alerter, demander: demander, grille: grille };
window.dialogue = dialogue;
